// @flow
import { connect } from 'react-redux';
import Purchased from '../components/Purchased';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState){
  return {
    locale: state.locale,
    motives: state.report.motives,
    order: state.order.order,
  };
}

export default connect(mapStateToProps)(Purchased);




// WEBPACK FOOTER //
// ./src/modules/order/Purchase/purchased/containers/PurchasedContainer.js